module.exports = __webpack_public_path__ + "img/1-1.6eb00d9c.jpg";